module.exports = __webpack_public_path__ + "img/col1.c78cb709.svg";